module.exports = __webpack_public_path__ + "img/xilinx.d30215ce.jpg";